import { Auth } from "aws-amplify";
import React, { Component } from "react";
import {
  Col,
  Form,
  FormControl,
  FormText,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import { MdCheckCircle, MdVisibility, MdVisibilityOff } from "react-icons/md";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import LoaderButton from "../components/LoaderButton";
import photo1 from "../images/photo1.svg";
import { Constants } from "../libs/Constants";
import { signupVerification } from "../libs/dbFunctions";
import {
  checkForNumbers,
  checkForSymbols,
  checkForUpperCase,
} from "../libs/utils";
import "./SignUp.scss";

const errorMessages = [
  {
    error: "8 Characters Minimum",
    state: false,
  },
  {
    error: "Contains a Capital Letter",
    state: false,
  },
  {
    error: "Contains a Number",
    state: false,
  },
  {
    error: "Contains a Symbol (,./?::!$%&*=+)",
    state: false,
  },
];
export default class SignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: "",
      email: "",
      userNotFound: false,
      password: "",
      codeSent: false,
      confirmed: false,
      confirmPassword: "",
      terms: false,
      isConfirming: false,
      isSendingCode: false,
      validated: false,
      pwdValidated: false,
      sendConfirmationForm: false,
      errors: errorMessages,
      visibility: false,
      passwordEntered: false,
    };
  }
  validateResetForm(password) {
    let checks = errorMessages;

    for (let item of checks) item.state = false;
    checks[0].state =
      password.length >= Constants.PASSWORD_LENGTH ? true : false;
    checks[1].state = checkForUpperCase(password);
    checks[2].state = checkForNumbers(password);
    checks[3].state = checkForSymbols(password);

    let inValid = [];
    let isValidated = false;
    inValid = checks.filter((item) => item.state === false);
    if (inValid && inValid.length > 0) isValidated = false;
    else isValidated = true;

    this.setState({
      errors: checks,
      pwdValidated: isValidated,
      passwordEntered: true,
    });
  }
  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });

    if (event.target.id === "password" && event.target.value.length > 0) {
      this.validateResetForm(event.target.value);
    }
  };

  handleSendCodeClick = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      this.setState({ validated: true });
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();

    this.setState({
      isSendingCode: true,
    });

    try {
      let verificationResp = await signupVerification(
        this.state.email.toLowerCase()
      );
      if (!verificationResp.initialSignUpReady) {
        throw new Error(
          "Please check with your company administrator to get invited to Taabl or try using the password reset flow if you have forgotten your password. Thank you!"
        );
      }

      await Auth.forgotPassword(this.state.email.toLowerCase());
      this.setState({
        codeSent: true,
      });
    } catch (e) {
      if (e.code === "UserNotFoundException") {
        this.setState({
          userNotFound: true,
        });
      } else {
        toast.error(e.message);
      }
      this.setState({
        isSendingCode: false,
      });
    }
  };

  handleConfirmClick = async (event) => {
    event.preventDefault();

    this.setState({
      isConfirming: true,
    });

    try {
      await Auth.forgotPasswordSubmit(
        this.state.email.toLowerCase(),
        this.state.code,
        this.state.password
      );
      this.setState({
        confirmed: true,
      });
    } catch (e) {
      toast.error(e.message);
      this.setState({
        isConfirming: false,
      });
    }
  };

  renderRequestCodeForm() {
    return (
      <Form
        noValidate
        validated={this.state.validated}
        onSubmit={this.handleSendCodeClick}
      >
        <Form.Group size="lg" controlId="email" className="form-group mb-4">
          <div>
            <Form.Label>Email Address </Form.Label>
          </div>

          <Form.Control
            required
            size="lg"
            autoFocus
            type="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
          <Form.Control.Feedback type="invalid">
            {!this.state.email || this.state.email.length === 0
              ? "This is required"
              : "Invalid email"}
          </Form.Control.Feedback>
          {this.state.email && this.state.userNotFound && (
            <Form.Control.Feedback className="invalid-feedback d-block">
              This email doesn’t match our records
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <div className="d-flex justify-content-center pb-3 font-secondary account">
          By signing up, I agree to Taabls
          <Link to="/login" className="secondary ps-1">
            Terms & Conditions
          </Link>
        </div>

        <LoaderButton
          block
          type="submit"
          variant="primary"
          size="lg"
          text="Next"
          className="mb-2"
          isLoading={this.state.isSendingCode}
        >
          Continue
        </LoaderButton>
        <div className="d-flex justify-content-center pt-4 font-secondary account">
          Already have an account?
          <Link to="/login" className="secondary ps-1">
            Log in
          </Link>
        </div>
      </Form>
    );
  }
  setPasswordVisibility() {
    this.setState({
      visibility: true,
    });
  }
  setPasswordInVisibility() {
    this.setState({
      visibility: false,
    });
  }
  renderConfirmationForm() {
    return (
      <Form onSubmit={this.handleConfirmClick}>
        <Form.Group size="lg" controlId="code" className={`form-group`}>
          <h2 className="text-center"> Create an Account </h2>
          <Form.Label className="password">Confirmation Code</Form.Label>

          <Form.Control
            required
            size="lg"
            autoFocus
            type="tel"
            value={this.state.code}
            onChange={this.handleChange}
          />
          <Form.Control.Feedback type="invalid">
            This is required.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group size="lg" controlId="password" className={`form-group`}>
          <Form.Label className="password"> Set Password </Form.Label>
          <InputGroup>
            <FormControl
              required
              size="lg"
              type={this.state.visibility ? "text" : "password"}
              value={this.state.password}
              onChange={this.handleChange}
            />
            <>
              {!this.state.visibility && (
                <InputGroup.Text
                  id="basic-addon2"
                  onClick={() => this.setPasswordVisibility()}
                >
                  <MdVisibility />
                </InputGroup.Text>
              )}
              {this.state.visibility && (
                <InputGroup.Text
                  id="basic-addon2"
                  onClick={() => this.setPasswordInVisibility()}
                >
                  <MdVisibilityOff />
                </InputGroup.Text>
              )}
            </>
            <Form.Control.Feedback type="invalid">
              This is required.
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
        {this.state.errors.map((item) => {
          return (
            <div>
              <FormText
                className={!item.state ? "passwordError" : "passwordOK"}
              >
                <MdCheckCircle
                  className={!item.state ? "checkBoxOutline" : "checkBox"}
                />
                {item.error}
              </FormText>
            </div>
          );
        })}
        {this.state.password && !this.state.pwdValidated && (
          <FormText className="passwordError">
            Needs to meet all requirements
          </FormText>
        )}
        <LoaderButton
          block
          className="button-padding"
          type="submit"
          variant="primary"
          size="lg"
          text="Set Password"
          isLoading={this.state.isConfirming}
          disabled={!this.state.pwdValidated}
        >
          Finish
        </LoaderButton>
      </Form>
    );
  }

  renderSuccessMessage() {
    return (
      <Modal.Body>
        <div className="text-center">
          <h3>Signup successful</h3>
          <p>
            <Link to="/login">
              Click here to login with your new credentials.
            </Link>
          </p>
        </div>
      </Modal.Body>
    );
  }
  setSendConfirmation() {
    this.setState({
      sendConfirmationForm: true,
    });
  }
  render() {
    return (
      <div className="d-flex justify-content-center bg-unauth-body">
        <Row className="w-100">
          <Col xs={12} sm={12} md={6}>
            <Row>
              <Col sm={3}></Col>
              <Col sm={6} className="app-form">
                {!this.state.codeSent && (
                  <React.Fragment>
                    <h2 className="text-center pb-3">Sign up with Taabl</h2>
                    {this.renderRequestCodeForm()}
                  </React.Fragment>
                )}
                {this.state.codeSent &&
                  !this.state.confirmed &&
                  !this.state.sendConfirmationForm && (
                    <div>
                      <h2 className="text-center pb-3">
                        We’ve sent you an email
                      </h2>
                      <LoaderButton
                        block
                        type="submit"
                        variant="primary"
                        size="lg"
                        onClick={() => this.setSendConfirmation()}
                      >
                        Continue
                      </LoaderButton>
                    </div>
                  )}
                {this.state.codeSent &&
                  !this.state.confirmed &&
                  this.state.sendConfirmationForm &&
                  this.renderConfirmationForm()}
                {this.state.codeSent &&
                  this.state.confirmed &&
                  this.renderSuccessMessage()}
                <div className="footer font-secondary text-light-grey">
                  <div>©taabl inc. 2020</div>
                </div>
              </Col>
              <Col sm={3}></Col>
            </Row>
          </Col>
          <Col xs={12} sm={12} md={6} className="d-sm-block mt-5 mt-lg-0">
            <div>
              <img src={photo1} className="w-100" />
              <h2 className="mt-5 text-center pb-3">Making ESPPs Simple</h2>
              <div className="text-center display-7 font-weight-normal">
                Taabl gives you all the benefits of your ESPP without the
                payroll deduction.
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
